import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getPrompts } from '../api/data-connectors/prompts'
import { resolvePromptLanguage } from '../types'

export function useGetPrompts() {
  const { i18n } = useTranslation()
  const lang = resolvePromptLanguage(i18n.resolvedLanguage)

  return useQuery({
    queryKey: ['prompts', lang],
    queryFn: () => getPrompts(lang),
    staleTime: 600_000, // 10 minutes
  })
}
